<template>
  <div :class="forTasks ? 'base-button calendar-button' : 'base-button'">
    <button :class="classNames" @click="buttonClicked($event)">
      <i v-if="isLoading" class="fa-spin fa-refresh fa"></i>
      {{title}}
    </button>
  </div>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    title: {
      type: String,
      default: ""
    },
    classNames: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    forTasks: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    buttonClicked(event) {
      event.preventDefault();
      this.$emit("clicked");
    }
  }
};
</script>

<style lang="scss">
.base-button {
  height: 100%;
  display: inline-block;
  position: relative;
  min-width: 140px !important;
  button {
    text-transform: none !important;
    width: 100%;
    @media(max-width: 1024px) {
      padding: 10px 8px;
      white-space: normal;
      overflow: hidden;
    }
  }
}

.calendar-button {
  margin-right: 10px;
  // position: absolute;
  // top: 90%;
  // float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/buttons/BaseButton.vue